export default {
  scenes: {
    uncoveringTheSabotage: {
      beats: {
        hiddenMessage: {
          events: [
            {
              type: 'showLocation',
              locationId: 'solarisInterior'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'Captain Elena Solara and Commander Kael Rhyder continue their investigation into the malfunction. After hours of sifting through encrypted ship logs, they discover a hidden message buried deep within the Solaris\' system.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Kael, did you have any idea this message was here? It\'s clearly been hidden.',
              choices: [
                {
                  text: 'Confront Kael About the Message',
                  next: {
                    scene: 'uncoveringTheSabotage',
                    beat: 'confrontKael'
                  }
                },
                {
                  text: 'Keep the Suspicion Internal',
                  next: {
                    scene: 'uncoveringTheSabotage',
                    beat: 'keepSuspicion'
                  }
                }
              ]
            }
          ]
        },
        confrontKael: {
          events: [
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'Kael, did you have any idea this message was here? It\'s clearly been hidden.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'thinking',
              text: 'No, I didn\'t. But someone clearly doesn\'t want us reaching our destination.'
            },
            {
              type: 'showNarration',
              text: 'The hidden message contains a series of coordinates leading to a seemingly abandoned station located in the farthest corner of the uncharted sector. Elena orders the crew to alter course toward the station to investigate further.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'Someone wants us to go there, and I need to know why.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'This could be a trap, Elena. We need to be careful.'
            }
          ],
          next: {
            scene: 'tensionsRising',
            beat: 'crewDivision'
          }
        },
        keepSuspicion: {
          events: [
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'I\'ll keep this to myself for now. I don\'t trust anyone completely on this crew, not even Kael.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'What\'s going on, Captain?'
            },
            {
              type: 'showNarration',
              text: 'The hidden message contains a series of coordinates leading to a seemingly abandoned station located in the farthest corner of the uncharted sector. Elena orders the crew to alter course toward the station to investigate further.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'Someone wants us to go there, and I need to know why.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'This could be a trap, Elena. We need to be careful.'
            }
          ],
          next: {
            scene: 'tensionsRising',
            beat: 'crewDivision'
          }
        }
      }
    },
    tensionsRising: {
      beats: {
        crewDivision: {
          events: [
            {
              type: 'showLocation',
              locationId: 'solarisInterior'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showNarration',
              text: 'As they head toward the coordinates, the crew begins to split on their opinions. Some are eager to investigate, while others are nervous about the potential risks. Zara Lee, Elena\'s second-in-command, approaches Elena with growing concerns about the mission\'s safety.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'Captain, I have some concerns about our current course of action.',
              choices: [
                {
                  text: 'Stay Confident',
                  next: {
                    scene: 'tensionsRising',
                    beat: 'stayConfident'
                  }
                },
                {
                  text: 'Acknowledge the Risk',
                  next: {
                    scene: 'tensionsRising',
                    beat: 'acknowledgeRisk'
                  }
                }
              ]
            }
          ]
        },
        stayConfident: {
          events: [
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'I understand your concerns, Zara, but we can\'t back down now. We\'re already this far in.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I trust you, Captain. But something doesn\'t feel right.'
            },
            {
              type: 'showNarration',
              text: 'The Solaris reaches the abandoned station. The crew notices strange energy fluctuations around the station\'s perimeter. The once-dormant structure seems to come alive with eerie hums as they approach.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'surprised',
              text: 'Something\'s not right. We\'ve been detected.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Prepare to board the station. Stay sharp, everyone.'
            }
          ],
          next: {
            scene: 'dangerousEncounter',
            beat: 'unexpectedHostiles'
          }
        },
        acknowledgeRisk: {
          events: [
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'sad',
              text: 'I know, Zara. I\'m not sure what we\'re walking into either. But we have no choice.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'Just keep us safe, Captain.'
            },
            {
              type: 'showNarration',
              text: 'The Solaris reaches the abandoned station. The crew notices strange energy fluctuations around the station\'s perimeter. The once-dormant structure seems to come alive with eerie hums as they approach.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'surprised',
              text: 'Something\'s not right. We\'ve been detected.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Prepare to board the station. Stay sharp, everyone.'
            }
          ],
          next: {
            scene: 'dangerousEncounter',
            beat: 'unexpectedHostiles'
          }
        }
      }
    },
    dangerousEncounter: {
      beats: {
        unexpectedHostiles: {
          events: [
            {
              type: 'showLocation',
              locationId: 'abandonedStation'
            },
            {
              type: 'showNarration',
              text: 'Upon docking at the station, the crew disembarks cautiously. As they explore, they\'re ambushed by hostile forces—unidentified mercenaries who appear to have been waiting for them.'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 10,
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'surprised',
              text: 'We\'re under attack!',
              choices: [
                {
                  text: 'Lead the Charge',
                  next: {
                    scene: 'dangerousEncounter',
                    beat: 'leadCharge'
                  }
                },
                {
                  text: 'Order a Retreat',
                  next: {
                    scene: 'dangerousEncounter',
                    beat: 'orderRetreat'
                  }
                }
              ]
            }
          ]
        },
        leadCharge: {
          events: [
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'Take cover! We fight back now!'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'surprised',
              text: 'Captain, let us handle this. You\'re too valuable to risk.'
            },
            {
              type: 'showNarration',
              text: 'The firefight intensifies as Elena and her crew are forced to engage in combat. The hostile forces are relentless, and the crew finds themselves outnumbered. Kael fights fiercely, covering Elena\'s back as they make their way through the station\'s corridors.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'angry',
              text: 'We\'re not leaving without answers. Stay close!'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We\'ll take them down one by one. Keep moving!'
            }
          ],
          goToChapter: {
            chapter: 'chapter3'
          }
        },
        orderRetreat: {
          events: [
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'Fall back! We need to regroup and reassess.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'Understood, Captain.'
            },
            {
              type: 'showNarration',
              text: 'The firefight intensifies as Elena and her crew are forced to engage in combat. The hostile forces are relentless, and the crew finds themselves outnumbered. Kael fights fiercely, covering Elena\'s back as they make their way through the station\'s corridors.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'angry',
              text: 'We\'re not leaving without answers. Stay close!'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We\'ll take them down one by one. Keep moving!'
            }
          ],
          goToChapter: {
            chapter: 'chapter3'
          }
        }
      }
    }
  }
}
